<div class="p-grid reasonCodeBody">
  <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 rootCommonContainer" *ngIf="showApp">
    <div class="p-grid reasonCodeBody" *ngIf="showReasonCodeBody()">
      <div class="paddingSection1 p-col-12 p-lg-12 p-md-12 p-sm-12">
        <div class="trackNumber">{{ 'TRACKING_NUMBER' | translate }}<a class="linkStyle" href="{{TRACKING_URL}}" target="_blank">&nbsp;{{awbNo}}</a></div>
        <div class="headFont">{{ 'INFO_REQ' | translate }}</div>
        <div class="fontAdjustAWB" *ngIf="showAwbLink||showCiLink||showECILink">{{ 'VIEW_AWB_DESC_1' | translate }}</div>
        <div class="fontAdjustAWB" *ngIf="showAwbLink"><a class="linkStyle" (click)="viewDocs('AWB')" target="_blank">{{ 'VIEW_AWB_DESC_2' | translate }}</a> </div>
        <div class="fontAdjustAWB" *ngIf="showCiLink"><a class="linkStyle" (click)="viewDocs('CI')" target="_blank">{{ 'VIEW_AWB_DESC_3' | translate }}</a> </div>
        <div class="fontAdjustAWB" *ngIf="showECILink"><a class="linkStyle" (click)="viewDocs('ECI')" target="_blank">{{ 'VIEW_AWB_DESC_4' | translate }}</a> </div>
        <div class="fontAdjustAWB">{{ 'COMMON_SENT_1' | translate }}</div>
      </div>
    </div>

    <div class="p-grid reasonCodeBody" *ngIf="PANEL9_POA_BOL_DE ||  PANEL10_NEORI_BOL_DE">
      <div class="paddingSection1 p-col-12 p-lg-12 p-md-12 p-sm-12">
        <div class="trackNumber">{{ 'POA_ACCOUNT' | translate }}&nbsp;{{awbNo}}</div>
        <div class="headFont">{{ 'POA_HEADER_CONTENT' | translate }}</div>
        <div class="fontAdjustAWB" *ngIf="showAwbLink || showCiLink">{{ 'VIEW_AWB_DESC_1' | translate }}<a class="linkStyle" (click)="viewDocs('AWB')" target="_blank">{{ 'VIEW_AWB_DESC_2' | translate }}</a> {{ 'VIEW_AWB_DESC_3' | translate }} <br /> <a class="linkStyle" (click)="viewDocs('CI')" target="_blank">{{ 'VIEW_AWB_DESC_4' | translate }}</a></div>
        <div class="fontAdjust01">{{ 'POA_HEADER_CONTENT_TEXT' | translate }}</div>
      </div>
    </div>

    <form class="p-grid reasonCodeAccordion bottomMargin" [formGroup]="reasonCodeForm" (ngSubmit)="submitInfo()">
      <!-- Reason codes accordion -->
      <p-accordion class="p-col-12 p-lg-12 p-md-12 p-sm-12">

        <!-- Begin reason code 'IMPNO' -->
        <p-accordionTab header="Consignee Import Identification Number" *ngIf="showReasonCode('IMPNO')" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img [src]="getReasonCodeStatusImage('IMPNO')" [alt]="getReasonCodeStatusDescription('IMPNO')" [title]="getReasonCodeStatusDescription('IMPNO')" />
            </span>
            <label class="accTabHeader">{{ 'IMPNO_TITLE' | translate }}</label>
          </p-header>
          <div *ngIf="showReasonCodeForm('IMPNO')" class="p-grid reasonCodeBody">
            <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="padBottom20">{{ 'IMPNO_PARA_1' | translate }}</div>
            </div>
            <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="padBottom20">
                {{ 'EORI_NUM_1' | translate }} <a class="linkStyle" href="{{ 'EORI_LOCAL_GOVT_LINK' | translate}}" target="_blank">{{ 'APPLY_EORI_LOC_GOV' | translate }}</a>
              </div>
            </div>
            <!-- Begin show private shipment details and control -->
            <div *ngIf="isImpnoPrivateShipmentEligible" class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="padBottom20">{{ 'PVT_SHIP' | translate }}
                <p-checkbox binary="true" [formControl]="reasonCodeForm.controls['impnoPrivateShipmentCheckBox']" (click)="impnoPrivateCheckBoxClicked()"></p-checkbox>
                <button [escape]="false" type="button" [pTooltip]=" 'PVT_SHIP_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
            </div>
            <!-- End show private shipment details and control -->

            <!-- Begin reason code body to show for non private 'IMPNO' reason code -->
            <div *ngIf="!isImpnoPrivateShipment" class="p-grid reasonCodeBody desciPadding">
              <div class="p-col-11 p-lg-11 p-md-11 p-sm-11">
                <input class="inputStyle" id="eori" type="text" formControlName="eori_impno" placeholder="{{ 'EORI_NUM_PLACEHOLD' | translate }}" 
                  maxlength="20" pInputText>
              </div>
              <div class="p-col-1 p-lg-1 p-md-1 p-sm-1 toolTipPadding">
                <button [escape]="false" type="button" [pTooltip]=" 'EORI_TOOL_TIP' | translate " class="btn-q toolTipStyle" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="getReasonCodeFormControls.eori_impno.errors" class="validationMsgIMPNONL p-col-12 p-lg-12 p-md-12 p-sm-12">{{ 'EORI_ERROR_MSG' | translate }}</div>
              <div class="p-col-11 p-lg-11 p-md-11 p-sm-11">
                <input class="inputStyle" id="vat" type="text" formControlName="vat_impno" placeholder="{{ 'VAT_NUM_PLACEHOLD' | translate }}" 
                  maxlength="20" pInputText>
              </div>
              <div class="p-col-1 p-lg-1 p-md-1 p-sm-1 toolTipPadding">
                <button [escape]="false" type="button" [pTooltip]=" 'VAT_TOOL_TIP' | translate " class="btn-q toolTipStyle" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="getReasonCodeFormControls.vat_impno.errors" class="validationMsgIMPNONL p-col-12 p-lg-12 p-md-12 p-sm-12">{{ 'VAT_ERROR_MSG' | translate}}</div>
            </div>
            <div *ngIf="!isImpnoPrivateShipment" class="paddingSection4 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div>
                <input type="file" #fileImpno (change)="handleFileInput($event,'impno',true)" [accept]="acceptedFileTypes" multiple>
                <button class="btn-upload" type="button" [disabled]="validateFiles" (click)="fileImpno.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate " class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNameImpno" class="fileLabelMargin">
                <div *ngFor="let item of tempImpno; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('impno')">{{item.name}}</label>
                    <span (click)="removeFile('impno',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorImpno" class="validationMsg">{{ 'FILE_SIZE_LIMIT' | translate }}</div>
              <div *ngIf="displayFileTypeErrorImpno" class="validationMsg">{{ 'FILE_FORMAT_MSG' | translate }}</div>
              <div>
                <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textArea"
                  formControlName="impnoCommentsNL" maxlength="1000"></textarea>
              </div>
            </div>
            <!-- End reason code body to show for non private 'IMPNO' reason code -->
            <!-- Begin reason code body to show for private shipment 'IMPNO' reason code -->
            <div *ngIf="isImpnoPrivateShipment" class="p-grid reasonCodeBody">
              <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 paddingSection5">
              <div class="desciPadding">{{ 'REASON_PVT_SHIP' | translate }}</div>
                <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textArea" id="impnoPrivateShipmentReason"
                  formControlName="impnoPrivateShipmentReason" maxlength="1000"></textarea>
              </div>
            </div>
            <!-- End reason code body to show for private shipment 'IMPNO' reason code -->
          </div>
          <div *ngIf="isReasonCodeStatusSubmitted('IMPNO')" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">{{ 'REASON_CODE_SUBMITTED_MSG' | translate }}</div>
          </div>
        </p-accordionTab>
        <!-- End reason code 'IMPNO' -->

        <!-- Begin reason code 'DEFR' -->
        <p-accordionTab header="Consignee Import Identification Number" *ngIf="showReasonCode('DEFR')" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img [src]="getReasonCodeStatusImage('DEFR')" [alt]="getReasonCodeStatusDescription('DEFR')" [title]="getReasonCodeStatusDescription('DEFR')" />
            </span>
            <label class="accTabHeader">{{ 'DEFR_TITLE' | translate }}</label>
          </p-header>
          <div *ngIf="showReasonCodeForm('DEFR')" class="p-grid reasonCodeBody">
            <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="padBottom20">{{ 'DEFR_PARA_1' | translate }}</div>
            </div>
            <div class="p-grid reasonCodeBody desciPadding">
              <div class="p-col-11 p-lg-11 p-md-11 p-sm-11">
                <input class="inputStyle" id="accNo" type="text" formControlName="accNo_defr" 
                  placeholder="{{ 'DEFR_NUM_PLACEHOLD' | translate }}" maxlength="7" (input)="validateDefrForm()"
                  pInputText>
              </div>
              <div class="p-col-1 p-lg-1 p-md-1 p-sm-1 toolTipPadding">
                <button [escape]="false" type="button" [pTooltip]=" 'DEFR_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="getReasonCodeFormControls.accNo_defr.errors"
                class="validationMsgIMPNONL p-col-12 p-lg-12 p-md-12 p-sm-12">{{ 'DEFR_ACCNO_ERROR_MSG' | translate }}</div>
            </div>
            <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="userInputDivPadding">
                <p-checkbox binary="true" [formControl]="reasonCodeForm.controls['nameDefrCheckBox']"
                  (click)="checkBoxValueForDefr()">
                </p-checkbox>
                <label class="ifontSize">&nbsp; {{ 'TNC_SENT_1' | translate }} &nbsp;</label>
                <input id="custNameDefr" type="text" formControlName="custNameDefr"
                  placeholder="{{ 'CUST_NAME_PLACEHOLDER' | translate }}" class="nameInput" maxlength="100" pInputText>
                <label>&nbsp;<b>{{ 'DEFR_SENT_2' | translate }}</b></label>
              </div>
            </div>
            <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="padBottom20">{{ 'DEFR_PARA_2' | translate }}</div>
            </div>
            <div class="paddingSection4 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div>
                <input type="file" #fileDefr (change)="handleFileInput($event,'defr',true)" [accept]="acceptedFileTypes" multiple>
                <button class="btn-upload" type="button" [disabled]="validateFiles" (click)="fileDefr.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNameDefr" class="fileLabelMargin">
                <div *ngFor="let item of tempDefr; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('defr')">{{item.name}}</label>
                    <span (click)="removeFile('defr',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorDefr" class="validationMsg">{{ 'FILE_SIZE_LIMIT' | translate }}</div>
              <div *ngIf="displayFileTypeErrorDefr" class="validationMsg">{{ 'FILE_FORMAT_MSG' | translate }}</div>
              <div>
                <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textArea"
                  formControlName="defrComments" maxlength="1000"></textarea>
              </div>
            </div>
          </div>
          <div *ngIf="isReasonCodeStatusSubmitted('DEFR')" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">{{ 'REASON_CODE_SUBMITTED_MSG' | translate }}</div>
          </div>
        </p-accordionTab>
        <!-- End reason code 'DEFR' -->

        <!-- Begin reason code 'IPRSN' -->
        <p-accordionTab header="Consignee Import Identification Number" *ngIf="showReasonCode('IPRSN')" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img [src]="getReasonCodeStatusImage('IPRSN')" [alt]="getReasonCodeStatusDescription('IPRSN')" [title]="getReasonCodeStatusDescription('IPRSN')" />
            </span>
              <label class="accTabHeader">{{ 'IPRSN_TITLE' | translate }}</label>
          </p-header>
          <div *ngIf="showReasonCodeForm('IPRSN')" class="p-grid reasonCodeBody">
            <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="padBottom20">{{ 'IPRSN_PARA_1' | translate }}</div>
            </div>
            <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="userInputDivPadding">
                <textarea class="inputStyleHsCode" id="reasonComments_iprsn" type="text"
                  formControlName="reasonComments_iprsn" rows="4" cols="50"  placeholder="{{ 'IPRSN_REASON_PLACEHOLD' | translate }}"
                  pInputTextarea maxlength="3000"  autocomplete="off" ></textarea>
              </div>
            </div>
            <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="padBottom20">{{ 'IPRSN_PARA_2' | translate }}</div>
            </div>
            <div class="paddingSection4 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div>
                <input type="file" #fileIprsn (change)="handleFileInput($event,'iprsn',true)" [accept]="acceptedFileTypes" multiple>
                <button class="btn-upload" type="button" [disabled]="validateFiles" (click)="fileIprsn.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNameIprsn" class="fileLabelMargin">
                <div *ngFor="let item of tempIprsn; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('defr')">{{item.name}}</label>
                    <span (click)="removeFile('iprsn',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorIprsn" class="validationMsg">{{ 'FILE_SIZE_LIMIT' | translate }}</div>
              <div *ngIf="displayFileTypeErrorIprsn" class="validationMsg">{{ 'FILE_FORMAT_MSG' | translate }}</div>
              <div>
                <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textArea"
                  formControlName="iprsnComments" maxlength="1000"></textarea>
              </div>
            </div>
          </div>
          <div *ngIf="isReasonCodeStatusSubmitted('IPRSN')" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">{{ 'REASON_CODE_SUBMITTED_MSG' | translate }}</div>
          </div>
        </p-accordionTab>
        <!-- End reason code 'IPRSN' -->

        <!-- Begin reason code 'DESCI' -->
        <p-accordionTab *ngIf="PANEL2_CST_DESCI_BOL" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img *ngIf="displayGreenTickIcon('PANEL2_CST_DESCI_BOL')" src="./assets/img/tick.png" alt="complete" />
              <img *ngIf="displayExclamationMarkIcon('PANEL2_CST_DESCI_BOL')" src="./assets/img/exclamation.png" alt="error" />
              <img *ngIf="displayGreenCircleIcon('PANEL2_CST_DESCI_BOL')" src="./assets/img/circleG.png" alt="new" />
            </span>
            <label class="accTabHeader">{{ 'DESCI_TITLE' | translate }}</label>
          </p-header>
          <div *ngIf="!DESCI_ALREADY_SUBMITED" class="p-grid reasonCodeBody paddingSectionHsCode">
            <div *ngIf="showmultipleHSHeader" class="hs-code-bold-head p-col-12 p-lg-12 p-md-12 p-sm-12">{{ 'MULTIPLE_HS_HEAD' | translate }}</div>
            <!--mul HS -->
            <div class="hs-code-desc">{{ 'DESCI_INSTRUCTION' | translate }}</div>
            <ng-container class="p-col-12 p-lg-12 p-md-12 p-sm-12" formArrayName="multipleHSValues"
              *ngFor="let HS of reasonCodeForm.get('multipleHSValues').controls; let i = index">
              <ng-container class="p-col-12 p-lg-12 p-md-12 p-sm-12" [formGroupName]="i">
                <div *ngIf="!showmultipleHSHeader" class="hs-code-bold-head p-col-12 p-lg-12 p-md-12 p-sm-12">{{ 'DESCI_LABEL_1' | translate }}</div>
                <div *ngIf="showmultipleHSHeader" class="hs-code-bold-head p-col-12 p-lg-12 p-md-12 p-sm-12">{{ 'MULTIPLE_HS_LABEL' | translate }}{{i + 1}}</div>
                <div class="hs-code-desc p-col-12 p-lg-12 p-md-12 p-sm-12">{{ 'DESCI_PARA_1' | translate }}</div>
                <div class="p-col-11 p-lg-11 p-md-11 p-sm-11">
                  <input id="hscode_desci" type="text" class="inputStyleHsCode" formControlName="harmonizedCode_desci"
                    placeholder="{{ 'HS_CODE_PLACEHOLD' | translate }}" pInputText minlength="6" [ngClass]="{ 'is-invalid': getReasonCodeFormControls.multipleHSValues.errors }">
                </div>
                <div class="p-col-1 p-lg-1 p-md-1 p-sm-1 toolTipPadding">
                  <button [escape]="false" type="button" [pTooltip]=" 'HS_CODE_TOOL_TIP_NL' | translate "
                    class="btn-q toolTipStyle" tooltipEvent="focus" hideDelay="400">
                    <em class="pi pi-question"></em>
                  </button>
                </div>
                <div *ngIf="getReasonCodeFormControls.multipleHSValues.status == 'INVALID'" class="validationMsg p-col-12 p-lg-12 p-md-12 p-sm-12">
                  {{ 'HS_CODE_ERROR_MSG' | translate }}
                </div> 
                <!--GB-DESCI-->
                <div class="hs-code-gb-link p-col-12 p-lg-12 p-md-12 p-sm-12" *ngIf="country === 'GB'">
                  {{ 'GB_DESCI_LINK_1' | translate }}<a target="_blank" class="linkStyle" href="{{GB_DESCI_URL}}">{{ 'GB_DESCI_LINK_2' | translate }}</a>
                </div>
                <!--GB-DESCI-->
                <div *ngIf="!showmultipleHSHeader" class="hs-code-bold-head p-col-12 p-lg-12 p-md-12 p-sm-12">{{ 'DESCI_LABEL_2' | translate }}</div>
                <div *ngIf="showmultipleHSHeader" class="hs-code-bold-head p-col-12 p-lg-12 p-md-12 p-sm-12">{{ 'ITEM_MULTIPLE_HS_LABEL' | translate }}{{i + 1}}</div>
                <div class="hs-code-desc p-col-12 p-lg-12 p-md-12 p-sm-12">{{ 'DESCI_PARA_2' | translate }}</div>
                <div class="p-col-11 p-lg-11 p-md-11 p-sm-11">
                  <textarea class="inputStyleHsCode" id="itemDesc_desci" type="text"
                    formControlName="itemDescription_desci" placeholder="{{ 'ITEM_DESCI_PLACEHOLD' | translate }}"
                    pInputTextarea maxlength="1000" autocomplete="off"></textarea>
                </div>
                <div class="p-col-1 p-lg-1 p-md-1 p-sm-1 toolTipPadding">
                  <button type="button" [pTooltip]=" 'ITEM_DESC_TOOL_TIP' | translate " class="btn-q toolTipStyle"
                    tooltipEvent="focus">
                    <em class="pi pi-question"></em>
                  </button>
                </div>
                <!--remove-DESCI-->
                <div *ngIf="showmultipleHSHeader && i!= 0" class="hs-code-mul p-col-12 p-lg-12 p-md-12 p-sm-12">
                  {{ 'HS_REMOVE_LINK_1' | translate }} <a class="linkStyle" (click)="removemultipleHSEntry(i)">{{ 'HS_REMOVE_LINK_2' | translate }}</a>
                </div>
                <!--remove-DESCI-->
                <hr *ngIf="showmultipleHSHeader" style="width:100%; text-align:center;" />
              </ng-container>
            </ng-container>
            <!--HS-DESCI-->
            <div class="hs-code-mul p-col-12 p-lg-12 p-md-12 p-sm-12">
              {{ 'HS_DESCI_LINK_1' | translate }} <a class="linkStyle" (click)="multipleHSEntry()">{{ 'HS_DESCI_LINK_2' | translate }}</a>
            </div>
            <!--HS-DESCI-->
            <!--mul HS-->
            <div class="commentSection p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div>
                <input type="file" #fileDesci (change)="handleFileInput($event,'desci',true)" [accept]="acceptedFileTypes" multiple>
                <button class="btn-upload" type="button" [disabled]="validateFiles"
                  (click)="fileDesci.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNameDesci" class="fileLabelMargin">
                <div *ngFor="let item of tempDesci; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('desci')">{{item.name}}</label>
                    <span (click)="removeFile('desci',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorDesci" class="validationMsg">{{ 'FILE_SIZE_LIMIT' | translate }}</div>
              <div *ngIf="displayFileTypeErrorDesci" class="validationMsg">{{ 'FILE_FORMAT_MSG' | translate }}</div>
              <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textAreaDesci"
                formControlName="desciComments" maxlength="1000"></textarea>
            </div>
          </div>
          <div *ngIf="DESCI_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">{{ 'REASON_CODE_SUBMITTED_MSG' | translate }}</div>
          </div>
        </p-accordionTab>

        <!-- Begin reason code 'VALUS' -->
        <p-accordionTab *ngIf="showReasonCode('VALUS')" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img [src]="getReasonCodeStatusImage('VALUS')" [alt]="getReasonCodeStatusDescription('VALUS')" [title]="getReasonCodeStatusDescription('VALUS')" />
            </span>
            <label class="accTabHeader">{{ 'VALUS_TITLE' | translate }}</label>
          </p-header>
          <div *ngIf="showReasonCodeForm('VALUS')" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 justifyText">
              <div>{{ 'VALUS_PARA_1' | translate }}</div>
            </div>
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 paddingSectionDufr">
              <div>
                <input type="file" #fileValues (change)="handleFileInput($event,'values',true)" [accept]="acceptedFileTypes" multiple>
                <button type="button" class="btn-upload" [disabled]="validateFiles"
                  (click)="fileValues.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNameValues" class="fileLabelMargin">
                <div *ngFor="let item of tempValus; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('values')">{{item.name}}</label>
                    <span (click)="removeFile('values',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorValues" class="validationMsg">{{ 'FILE_SIZE_LIMIT' | translate }}</div>
              <div *ngIf="displayFileTypeErrorValues" class="validationMsg">{{ 'FILE_FORMAT_MSG' | translate }}</div>
            </div>
            <div class="commentSection p-col-12 p-lg-12 p-md-12 p-sm-12">
              <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textArea"
                formControlName="valusComments" maxlength="1000"></textarea>
            </div>
          </div>
          <div *ngIf="isReasonCodeStatusSubmitted('VALUS')" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">{{ 'REASON_CODE_SUBMITTED_MSG' | translate }}</div>
          </div>
        </p-accordionTab>
        <!-- End reason code 'VALUS' -->

        <!-- Begin reason code 'PFEXP' -->
        <p-accordionTab *ngIf="PANEL6_EXP_BOL" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img *ngIf="displayGreenTickIcon('PANEL6_EXP_BOL')" src="./assets/img/tick.png" alt="complete" />
              <img *ngIf="displayExclamationMarkIcon('PANEL6_EXP_BOL')" src="./assets/img/exclamation.png" alt="error" />
              <img *ngIf="displayGreenCircleIcon('PANEL6_EXP_BOL')" src="./assets/img/circleG.png" alt="new" />
            </span>
            <label class="accTabHeader">{{ 'PFEXP_TITLE' | translate }}</label>
          </p-header>
          <div *ngIf="!PFEXP_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 justifyText">
               <div [innerHTML]="getPfexpContent()">
              </div>
            </div>
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 paddingSectionDufr">
              <div>
                <input type="file" #filePfexp (change)="handleFileInput($event,'pfexp',true)" [accept]="acceptedFileTypes" multiple>
                <button type="button" class="btn-upload" [disabled]="validateFiles"
                  (click)="filePfexp.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'PFEXP_UPLOAD_FILE_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNamePfexp" class="fileLabelMargin">
                <div *ngFor="let item of tempPfexp; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('pfexp')">{{item.name}}</label>
                    <span (click)="removeFile('pfexp',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorPfexp" class="validationMsg">{{ 'FILE_SIZE_LIMIT' | translate }}</div>
              <div *ngIf="displayFileTypeErrorPfexp" class="validationMsg">{{ 'FILE_FORMAT_MSG' | translate }}</div>
            </div>
            <div class="commentSection p-col-12 p-lg-12 p-md-12 p-sm-12">
              <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textArea"
                formControlName="pfexpComments" maxlength="1000"></textarea>
            </div>
          </div>
          <div *ngIf="PFEXP_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">{{ 'REASON_CODE_SUBMITTED_MSG' | translate }}</div>
          </div>
        </p-accordionTab>
        <!-- End reason code 'PFEXP' -->

        <!-- Begin reason code 'INVMS' -->
        <p-accordionTab *ngIf="PANEL7_INVMS_BOL" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img *ngIf="displayGreenTickIcon('PANEL7_INVMS_BOL')" src="./assets/img/tick.png" alt="complete" />
              <img *ngIf="displayExclamationMarkIcon('PANEL7_INVMS_BOL')" src="./assets/img/exclamation.png" alt="error" />
              <img *ngIf="displayGreenCircleIcon('PANEL7_INVMS_BOL')" src="./assets/img/circleG.png" alt="new" />
            </span>
            <label class="accTabHeader">{{ 'INVMS_TITLE' | translate }}</label>
          </p-header>
          <div *ngIf="!INVMS_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 justifyText">
              <div>{{ 'INVMS_PARA_1' | translate }}</div>
            </div>
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 paddingSectionDufr">
              <div>
                <input type="file" #fileInvms (change)="handleFileInput($event,'invms',true)" [accept]="acceptedFileTypes" multiple>
                <button type="button" class="btn-upload" [disabled]="validateFiles"
                  (click)="fileInvms.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNameInvms" class="fileLabelMargin">
                <div *ngFor="let item of tempInvms; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('invms')">{{item.name}}</label>
                    <span (click)="removeFile('invms',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorInvms" class="validationMsg">{{ 'FILE_SIZE_LIMIT' | translate }}</div>
              <div *ngIf="displayFileTypeErrorInvms" class="validationMsg">{{ 'FILE_FORMAT_MSG' | translate }}</div>
            </div>
            <div class="commentSection p-col-12 p-lg-12 p-md-12 p-sm-12">
              <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textArea"
                formControlName="invmsComments" maxlength="1000"></textarea>
            </div>
          </div>
          <div *ngIf="INVMS_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">{{ 'REASON_CODE_SUBMITTED_MSG' | translate }}</div>
          </div>
        </p-accordionTab>
        <!-- End reason code 'INVMS' -->

        <!-- GENERIC Reason Code -->
        <p-accordionTab *ngIf="PANEL8_GNRIC_BOL" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img *ngIf="displayGreenTickIcon('PANEL8_GNRIC_BOL')" src="./assets/img/tick.png" alt="complete" />
              <img *ngIf="displayExclamationMarkIcon('PANEL8_GNRIC_BOL')" src="./assets/img/exclamation.png"
                alt="error" />
              <img *ngIf="displayGreenCircleIcon('PANEL8_GNRIC_BOL')" src="./assets/img/circleG.png" alt="new" />
            </span>
            <label class="accTabHeader">{{ 'GNRIC_TITLE' | translate }}</label>
          </p-header>
          <div *ngIf="!GNRIC_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 justifyText">
              <div>
                {{ 'GNRIC_PARA_1' | translate }}
              </div>
            </div>
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 paddingSectionDufr">
              <div>
                <input type="file" #fileGnric (change)="handleFileInput($event,'gnric',true)" [accept]="acceptedFileTypes" multiple>
                <button type="button" class="btn-upload" [disabled]="validateFiles" (click)="fileGnric.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate " class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNameGnric" class="fileLabelMargin">
                <div *ngFor="let item of tempGnric; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('gnric')">{{item.name}}</label>
                    <span (click)="removeFile('gnric',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorGnric" class="validationMsg">
                {{ 'FILE_SIZE_LIMIT' | translate }}
              </div>
              <div *ngIf="displayFileTypeErrorGnric" class="validationMsg">
                {{ 'FILE_FORMAT_MSG' | translate }}
              </div>
            </div>
            <div class="commentSection p-col-12 p-lg-12 p-md-12 p-sm-12">
              <textarea pInputTextarea placeholder="{{ 'PROVIDE_INFO' | translate }}" class="textArea"
                formControlName="gnricComments" maxlength="1000"></textarea>
            </div>
          </div>
          <div *ngIf="GNRIC_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">
              {{ 'REASON_CODE_SUBMITTED_MSG' | translate }}
            </div>
          </div>
        </p-accordionTab>
        <!-- DUFR Reason Code -->
        <p-accordionTab *ngIf="PANEL4_DUFR_BOL" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img *ngIf="displayGreenTickIcon('PANEL4_DUFR_BOL')" src="./assets/img/tick.png" alt="complete" />
              <img *ngIf="displayExclamationMarkIcon('PANEL4_DUFR_BOL')" src="./assets/img/exclamation.png"
                alt="error" />
              <img *ngIf="displayGreenCircleIcon('PANEL4_DUFR_BOL')" src="./assets/img/circleG.png" alt="new" />
            </span>
            <label class="accTabHeader">{{ 'DUFR_TITLE' | translate }}</label>
          </p-header>
          <div class="p-grid reasonCodeBody" *ngIf="!DUFR_ALREADY_SUBMITED">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 justifyText">
              <div>{{ 'DUFR_PARA_1' | translate }}</div>
            </div>
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 paddingSectionDufr">
              <div>
                <input type="file" #fileDufr (change)="handleFileInput($event,'dufr',true)" [accept]="acceptedFileTypes" multiple>
                <button type="button" class="btn-upload" [disabled]="validateFiles" (click)="fileDufr.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate " class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNameDufr" class="fileLabelMargin">
                <div *ngFor="let item of tempDufrPH; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('dufr')">{{item.name}}</label>
                    <span (click)="removeFile('dufr',i)" (change)="handleFileInput($event,'dufr',true)"
                      class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorDufr" class="validationMsg">
                {{ 'FILE_SIZE_LIMIT' | translate }}
              </div>
              <div *ngIf="displayFileTypeErrorDufr" class="validationMsg">
                {{ 'FILE_FORMAT_MSG' | translate }}
              </div>
              <div class="samplePadding">
                <a class="linkStyle01" target="_blank" href='./assets/sample/DufrSample.pdf'>
                {{ 'DUFR_SAMPLE' | translate }}
                </a>
              </div>
              <div class="commentSection p-col-12 p-lg-12 p-md-12 p-sm-12">
                <textarea pInputTextarea placeholder="Comments" class="textArea" formControlName="dufrComments"
                  maxlength="1000"></textarea>
              </div>
            </div>
          </div>
          <div *ngIf="DUFR_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">
              {{ 'REASON_CODE_SUBMITTED_MSG' | translate }}
            </div>
          </div>
        </p-accordionTab>

        <!-- IMPNO - PH ReasonCode -->
        <p-accordionTab *ngIf="PANEL5_COR_IMPNO_BOL" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img *ngIf="displayGreenTickIcon('PANEL5_COR_IMPNO_BOL')" src="./assets/img/tick.png" alt="complete" />
              <img *ngIf="displayExclamationMarkIcon('PANEL5_COR_IMPNO_BOL')" src="./assets/img/exclamation.png"
                alt="error" />
              <img *ngIf="displayGreenCircleIcon('PANEL5_COR_IMPNO_BOL')" src="./assets/img/circleG.png" alt="new" />
            </span>
            <label class="accTabHeader">Consignee Import Identification Number</label>
          </p-header>
          <div class="p-grid reasonCodeBody" *ngIf="!IMPNO_COR_ALREADY_SUBMITED">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div>
                Please upload the Certificate of Registration (COR) to complete the Customs Regulation Requirement.
                By issuance of this certificate, the application signifies agreement to the following conditions:
                <ol>
                  <li class="li-tnc">Compliance to Customs Memorandum Order (CMO) and its subsequent issuance governing
                    Client Registration
                    Application Processing.
                  </li>
                  <li class="li-tnc">Non-repudiation of any declaration filed through the Value Added Service
                    Provider(s) (VASP).</li>
                  <li class="li-tnc">Recognition of TWM system information duly certified by its Administrator as valid
                    and/or correct.</li>
                </ol>
              </div>
            </div>
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 paddingSection4">
              <div>
                <input type="file" #fileImpno (change)="handleFileInput($event,'impno',true)" [accept]="acceptedFileTypes" multiple>
                <button class="btn-upload" type="button" [disabled]="validateFiles" (click)="fileImpno.click()">UPLOAD
                  FILE</button>
                <button [escape]="false" type="button" [pTooltip]="UPLOAD_FILE_TOOL_TIP"
                  class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNameImpno" class="fileLabelMargin">
                <div *ngFor="let item of tempImpnoPH; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('impno')">{{item.name}}</label>
                    <span (click)="removeFile('impno',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorImpno" class="validationMsg">
                {{ 'FILE_SIZE_LIMIT' | translate }}
              </div>
              <div *ngIf="displayFileTypeErrorImpno" class="validationMsg">
                {{ 'FILE_FORMAT_MSG' | translate }}
              </div>
              <div class="samplePadding">
                <a class="linkStyle01" target="_blank" href='./assets/sample/CORsample.png'>VIEW SAMPLE COR</a>
              </div>
              <div class="commentSection p-col-12 p-lg-12 p-md-12 p-sm-12">
                <textarea pInputTextarea placeholder="Comments" class="textArea" formControlName="impnoCommentsPH"
                  maxlength="1000"></textarea>
              </div>
            </div>
          </div>
          <div *ngIf="IMPNO_COR_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">
              {{ 'REASON_CODE_SUBMITTED_MSG' | translate }}
            </div>
          </div>
        </p-accordionTab>

        <!-- Begin reason code 'INVOR' -->
        <p-accordionTab *ngIf="PANEL13_INFOR_BOL" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img *ngIf="displayGreenTickIcon('PANEL13_INFOR_BOL')" src="./assets/img/tick.png" alt="complete" />
              <img *ngIf="displayExclamationMarkIcon('PANEL13_INFOR_BOL')" src="./assets/img/exclamation.png" alt="error" />
              <img *ngIf="displayGreenCircleIcon('PANEL13_INFOR_BOL')" src="./assets/img/circleG.png" alt="new" />
            </span>
            <label class="accTabHeader">{{ 'INFOR_TITLE' | translate }}</label>
          </p-header>
          <div *ngIf="!INFOR_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 justifyText">
              <div>{{ 'INFOR_PARA_1' | translate }}</div>
            </div>
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 paddingSectionDufr">
              <div>
                <input type="file" #fileInfor (change)="handleFileInput($event,'infor',true)" [accept]="acceptedFileTypes" multiple>
                <button type="button" class="btn-upload" [disabled]="validateFiles" (click)="fileInfor.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNameInfor" class="fileLabelMargin">
                <div *ngFor="let item of tempInfor; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('infor')">{{item.name}}</label>
                    <span (click)="removeFile('infor',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorInfor" class="validationMsg">{{ 'FILE_SIZE_LIMIT' | translate }}</div>
              <div *ngIf="displayFileTypeErrorInfor" class="validationMsg">{{ 'FILE_FORMAT_MSG' | translate }}</div>
            </div>
            <div class="commentSection p-col-12 p-lg-12 p-md-12 p-sm-12">
              <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textArea"
                formControlName="inforComments" maxlength="1000"></textarea>
            </div>
          </div>
          <div *ngIf="INFOR_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">{{ 'REASON_CODE_SUBMITTED_MSG' | translate }}</div>
          </div>
        </p-accordionTab>
        <!-- End reason code 'INVOR' -->

        <!-- Begin reason code 'MANIC' -->
        <p-accordionTab header="Consignee Import Identification Number" *ngIf="showReasonCode('MANIC')" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img [src]="getReasonCodeStatusImage('MANIC')" [alt]="getReasonCodeStatusDescription('MANIC')" [title]="getReasonCodeStatusDescription('MANIC')" />
            </span>
            <label class="accTabHeader">{{ 'MANIC_TITLE' | translate }}</label>
          </p-header>
          <div *ngIf="showReasonCodeForm('MANIC')" class="p-grid reasonCodeBody">
            <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="padBottom20">{{ 'MANIC_PARA_1' | translate }}</div>
            </div>
            <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="userInputDivPadding">
                <textarea class="inputStyleHsCode" id="reasonComments_manic" type="text"
                  formControlName="reasonComments_manic" rows="4" cols="50"  
                  pInputTextarea maxlength="3000"  autocomplete="off" ></textarea>
              </div>
            </div>
            <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="padBottom20">{{ 'MANIC_PARA_2' | translate }}</div>
            </div>
            <div class="paddingSection4 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div>
                <input type="file" #fileManic (change)="handleFileInput($event,'manic',true)" [accept]="acceptedFileTypes" multiple>
                <button class="btn-upload" type="button" [disabled]="validateFiles" (click)="fileManic.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
                <div *ngIf="fileNameManic" class="fileLabelMargin">
                <div *ngFor="let item of tempManic; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('manic')">{{item.name}}</label>
                    <span (click)="removeFile('manic',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorManic" class="validationMsg">{{ 'FILE_SIZE_LIMIT' | translate }}</div>
              <div *ngIf="displayFileTypeErrorManic" class="validationMsg">{{ 'FILE_FORMAT_MSG' | translate }}</div>
              <div>
                <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textArea"
                  formControlName="manicComments" maxlength="1000"></textarea>
              </div>
            </div>
          </div>
          <div *ngIf="isReasonCodeStatusSubmitted('MANIC')" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">{{ 'REASON_CODE_SUBMITTED_MSG' | translate }}</div>
          </div>
        </p-accordionTab>
        <!-- End reason code 'MANIC' -->

        <!-- POA Reason Code for countries other than DE -->
        <p-accordionTab *ngIf="PANEL9_POA_BOL" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img *ngIf="displayGreenTickIcon('PANEL9_POA_BOL')" src="./assets/img/tick.png" alt="complete" />
              <img *ngIf="displayExclamationMarkIcon('PANEL9_POA_BOL')" src="./assets/img/exclamation.png"
                alt="error" />
              <img *ngIf="displayGreenCircleIcon('PANEL9_POA_BOL')" src="./assets/img/circleG.png" alt="new" />
            </span>
            <label class="accTabHeader">{{ 'POA' | translate }}</label>
          </p-header>
          <div class="p-grid reasonCodeBody" *ngIf="!POA_ALREADY_SUBMITED">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12">
              <!--
                show the translated version of the tag POA-CONTENT by calling the function getPoaContent() in
                'common-reason-code.component.ts' instead of coding the content like below
                {{ 'POA-CONTENT' | translate }}
                as innerHTML fails when invoking translate directly.
               -->
              <div class='padBottom20' [innerHTML]="getPoaContent()">
              </div>

            </div>
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 paddingSectionDufr">
              <div>
                <input type="file" #filePoa (change)="handleFileInput($event,'poa',true)" [accept]="acceptedFileTypes" multiple>
                <button type="button" class="btn-upload" [disabled]="validateFiles" (click)="filePoa.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate " class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNamePoa" class="fileLabelMargin">
                <div *ngFor="let item of tempPoa; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('poa')">{{item.name}}</label>
                    <span (click)="removeFile('poa',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorPoa" class="validationMsg">
                {{ 'FILE_SIZE_LIMIT' | translate }}
              </div>
              <div *ngIf="displayFileTypeErrorPoa" class="validationMsg">
                {{ 'FILE_FORMAT_MSG' | translate }}
              </div>
            </div>
            <div class="commentSection p-col-12 p-lg-12 p-md-12 p-sm-12">
              <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textArea"
                formControlName="poaComments" maxlength="1000"></textarea>
            </div>
          </div>
          <div *ngIf="POA_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">
              {{ 'REASON_CODE_SUBMITTED_MSG' | translate }}
            </div>
          </div>
        </p-accordionTab>

        <!-- POA Reason Code  for  DE-->
        <p-accordionTab *ngIf="PANEL9_POA_BOL_DE" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img *ngIf="displayGreenTickIcon('PANEL9_POA_BOL_DE')" src="./assets/img/tick.png" alt="complete" />
              <img *ngIf="displayExclamationMarkIcon('PANEL9_POA_BOL_DE')" src="./assets/img/exclamation.png"
                alt="error" />
              <img *ngIf="displayGreenCircleIcon('PANEL9_POA_BOL_DE')" src="./assets/img/circleG.png" alt="new" />
            </span>
            <label class="accTabHeader">{{ 'POA' | translate }}</label>
          </p-header>
          <div class="p-grid reasonCodeBody" *ngIf="!POA_ALREADY_SUBMITED">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12">
              <!--
                show the translated version of the tag POA-CONTENT by calling the function getPoaContent() in
                'common-reason-code.component.ts' instead of coding the content like below
                {{ 'POA-CONTENT' | translate }}
                as innerHTML fails when invoking translate directly.
               -->
              <div class='padBottom20' [innerHTML]="getPoaContent()">
              </div>
               <!--dont want option-->
               <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
                <div class="padBottom20" *ngIf="showPoaDontWantOption">{{ 'POA_DONT_WANT_OPTION' | translate }} <p-checkbox binary="true"
                    [formControl]="reasonCodeForm.controls['poaOptionCheckBox']" (click)="poaDontWantOptionCheckBoxValue()">
                  </p-checkbox>
                </div>
              </div>
              <!--dont want option-->
              <!--POA-temp-DE-->
              <div *ngIf="country === 'DE'" class="poa-code-temp p-col-12 p-lg-12 p-md-12 p-sm-12" >
                {{ 'POA_TEMP_LINK_1' | translate }} <a class="linkStyle" (click)="downloadDEPOATemplate()" > {{
                  'POA_TEMP_LINK_2' | translate }}</a>&nbsp; {{ 'POA_TEMP_LINK_3' | translate }}
              </div>
              <!--POA-temp-DE-->
            </div>
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 paddingSectionDufr">
              <div>
                <input type="file" #filePoa (change)="handleFileInput($event,'poa',true)" [accept]="acceptedFileTypes" multiple>
                <button type="button" class="btn-upload" [disabled]="validateFiles || showPoaContent" (click)="filePoa.click()">{{
                  'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNamePoa" class="fileLabelMargin">
                <div *ngFor="let item of tempPoa; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('poa')">{{item.name}}</label>
                    <span (click)="removeFile('poa',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorPoa" class="validationMsg">
                {{ 'FILE_SIZE_LIMIT' | translate }}
              </div>
              <div *ngIf="displayFileTypeErrorPoa" class="validationMsg">
                {{ 'FILE_FORMAT_MSG' | translate }}
              </div>
            </div>
            <div class="commentSection p-col-12 p-lg-12 p-md-12 p-sm-12">
              <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textArea"
                formControlName="poaComments" maxlength="1000"></textarea>
            </div>
          </div>
          <div *ngIf="POA_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">
              {{ 'REASON_CODE_SUBMITTED_MSG' | translate }}
            </div>
          </div>
        </p-accordionTab>
        
        <!-- new reason code EORI FOR NL-->
        <p-accordionTab *ngIf="PANEL10_NEORI_BOL" [selected]="keepDefaultSingleOpen">
          <p-header>
            <span>
              <img *ngIf="displayGreenTickIcon('PANEL10_NEORI_BOL')" src="./assets/img/tick.png" alt="complete" />
              <img *ngIf="displayExclamationMarkIcon('PANEL10_NEORI_BOL')" src="./assets/img/exclamation.png"
                alt="error" />
              <img *ngIf="displayGreenCircleIcon('PANEL10_NEORI_BOL')" src="./assets/img/circleG.png" alt="new" />
            </span>
            <label class="accTabHeader">{{ 'NEORI' | translate }}</label>
          </p-header>
          <div *ngIf="!NEORI_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="padBottom20">{{ 'NEORI_CONTENT' | translate }}</div>
            </div>
            <div class="p-grid reasonCodeBody desciPadding">
              <div class="p-col-11 p-lg-11 p-md-11 p-sm-11">
                <input class="inputStyle" id="eori" type="text" formControlName="eori_neori"
                  placeholder="{{ 'EORI_NUM_PLACEHOLD' | translate }}" maxlength="20" (input)="validateNeoriForm()"
                  pInputText>
              </div>
              <div class="p-col-1 p-lg-1 p-md-1 p-sm-1 toolTipPadding">
                <button [escape]="false" type="button" [pTooltip]=" 'EORI_TOOL_TIP_NEW' | translate "
                  class="btn-q toolTipStyle" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="getReasonCodeFormControls.eori_neori.errors"
                class="validationMsgIMPNONL p-col-12 p-lg-12 p-md-12 p-sm-12">
                {{ 'EORI_ERROR_MSG' | translate }}
              </div>
              <div class="p-col-11 p-lg-11 p-md-11 p-sm-11">
                <input class="inputStyle" id="vat" type="text" formControlName="vat_neori"
                  placeholder="{{ 'VAT_NUM_PLACEHOLD' | translate }}" maxlength="14" (input)="validateNeoriForm()"
                  pInputText>
              </div>
              <div class="p-col-1 p-lg-1 p-md-1 p-sm-1 toolTipPadding">
                <button [escape]="false" type="button" [pTooltip]=" 'VAT_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="getReasonCodeFormControls.vat_neori.errors"
                class="validationMsgIMPNONL p-col-12 p-lg-12 p-md-12 p-sm-12">
                {{ 'VAT_ERROR_MSG' | translate}}
              </div>
            </div>
            <div class="paddingSection4 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div>
                <input type="file" #fileNeori (change)="handleFileInput($event,'neori',true)" [accept]="acceptedFileTypes" multiple>
                <button class="btn-upload" [disabled]="validateFiles" type="button"
                  (click)="fileNeori.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNameNeori" class="fileLabelMargin">

                <div *ngFor="let item of tempNeori; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">

                    <label class="enable-cursor" (click)="previewFile('neori')">{{item.name}}</label>
                    <span (click)="removeFile('neori',i)" (change)="handleFileInput($event,'neori',true)"
                      class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorNeori" class="validationMsg">
                {{ 'FILE_SIZE_LIMIT' | translate }}
              </div>
              <div *ngIf="displayFileTypeErrorNeori" class="validationMsg">
                {{ 'FILE_FORMAT_MSG' | translate }}
              </div>
              <div>
                <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textArea"
                  formControlName="neoriCommentsNL" maxlength="1000"></textarea>
              </div>
            </div>
          </div>
          <div *ngIf="NEORI_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">
              {{ 'REASON_CODE_SUBMITTED_MSG' | translate }}
            </div>
          </div>
        </p-accordionTab>
        <!-- new reason code EORI -->

        <!-- new reason code EORI FOR DE-->
        <p-accordionTab *ngIf="PANEL10_NEORI_BOL_DE" [selected]="keepDefaultSingleOpen">

          <p-header>
            <span>
              <img *ngIf="displayGreenTickIcon('PANEL10_NEORI_BOL_DE')" src="./assets/img/tick.png" alt="complete" />
              <img *ngIf="displayExclamationMarkIcon('PANEL10_NEORI_BOL_DE')" src="./assets/img/exclamation.png"
                alt="error" />
              <img *ngIf="displayGreenCircleIcon('PANEL10_NEORI_BOL_DE')" src="./assets/img/circleG.png" alt="new" />
            </span>
            <label class="accTabHeader">{{ 'NEORI' | translate }}</label>
          </p-header>
          <div *ngIf="!NEORI_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="paddingSection3 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div class="padBottom20">{{ 'NEORI_CONTENT' | translate }}</div>
            </div>
            <div class="p-grid reasonCodeBody desciPadding">
              <div class="p-col-11 p-lg-11 p-md-11 p-sm-11">
                <input class="inputStyle" id="eori" type="text" formControlName="eori_neori"
                  placeholder="{{ 'EORI_NUM_PLACEHOLD' | translate }}" maxlength="20" (input)="validateNeoriForm()"
                  pInputText>
              </div>
              <div class="p-col-1 p-lg-1 p-md-1 p-sm-1 toolTipPadding">
                <button [escape]="false" type="button" [pTooltip]=" 'EORI_TOOL_TIP_NEW' | translate "
                  class="btn-q toolTipStyle" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="getReasonCodeFormControls.eori_neori.errors"
                class="validationMsgIMPNONL p-col-12 p-lg-12 p-md-12 p-sm-12">
                {{ 'EORI_ERROR_MSG' | translate }}
              </div>
              <div class="p-col-11 p-lg-11 p-md-11 p-sm-11">
                <input class="inputStyle" id="vat" type="text" formControlName="vat_neori"
                  placeholder="{{ 'VAT_NUM_PLACEHOLD' | translate }}" maxlength="14" (input)="validateNeoriForm()"
                  pInputText>
              </div>
              <div class="p-col-1 p-lg-1 p-md-1 p-sm-1 toolTipPadding">
                <button [escape]="false" type="button" [pTooltip]=" 'VAT_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="getReasonCodeFormControls.vat_neori.errors"
                class="validationMsgIMPNONL p-col-12 p-lg-12 p-md-12 p-sm-12">
                {{ 'VAT_ERROR_MSG' | translate}}
              </div>
            </div>
            <div class="paddingSection4 p-col-12 p-lg-12 p-md-12 p-sm-12">
              <div>
                <input type="file" #fileNeori (change)="handleFileInput($event,'neori',true)" [accept]="acceptedFileTypes" multiple>
                <button class="btn-upload" [disabled]="validateFiles" type="button"
                  (click)="fileNeori.click()">{{ 'UPLOAD_BTN' | translate }}</button>
                <button [escape]="false" type="button" [pTooltip]=" 'UPLOAD_FILE_TOOL_TIP' | translate "
                  class="btn-q toolTipStyle leftMarginToolTip" tooltipEvent="focus" hideDelay="400">
                  <em class="pi pi-question"></em>
                </button>
              </div>
              <div *ngIf="fileNameNeori" class="fileLabelMargin">
                <div *ngFor="let item of tempNeori; let i=index" style="padding-top: 10px">
                  <span class="label-file-name">
                    <label class="enable-cursor" (click)="previewFile('neori')">{{item.name}}</label>
                    <span (click)="removeFile('neori',i)" class="padding-x">&times;</span>
                  </span>
                </div>
              </div>
              <div *ngIf="displayFileSizeErrorNeori" class="validationMsg">
                {{ 'FILE_SIZE_LIMIT' | translate }}
              </div>
              <div *ngIf="displayFileTypeErrorNeori" class="validationMsg">
                {{ 'FILE_FORMAT_MSG' | translate }}
              </div>
              <div>
                <textarea pInputTextarea placeholder="{{ 'COMMENTS_PLACEHOLDER' | translate }}" class="textArea"
                  formControlName="neoriCommentsNL" maxlength="1000"></textarea>
              </div>
            </div>
          </div>
          <div *ngIf="NEORI_ALREADY_SUBMITED" class="p-grid reasonCodeBody">
            <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 submittedValidationMsg">
              {{ 'REASON_CODE_SUBMITTED_MSG' | translate }}
            </div>
          </div>
        </p-accordionTab>
        <!-- new reason code EORI -->
      </p-accordion>

      <div class="p-col-12 p-lg-12 p-md-12 p-sm-12" *ngIf="showSubmitDetailsDiv">
        <div class="paddingSection5">
          <div class="userInputDivPadding">
            <p-checkbox binary="true" [formControl]="reasonCodeForm.controls['nameCheckBox']" (click)="checkBoxValue()">
            </p-checkbox>
            <label class="ifontSize">&nbsp; {{ 'TNC_SENT_1' | translate }} &nbsp;</label>
            <input id="custName" type="text" formControlName="custName"
              placeholder="{{ 'CUST_NAME_PLACEHOLDER' | translate }}" class="nameInput" maxlength="100" pInputText>
            <label>
              &nbsp; {{ 'TNC_SENT_2' | translate }}
			  <a href="assets/terms-and-conditions.html" target="_blank" class="linkStyle">{{ 'TNC_SENT_3' | translate }}</a>
            </label>
          </div>
          <div class="feedbackText" *ngIf="showFeedbackMsg">
            {{feedbackMsg}}
          </div>
          <button class="submitBtn" type="submit" [disabled]="isSubmitButtonDisabled()">{{ 'SUBMIT_BTN' | translate }}</button>
            <!--add timer-->
            <div class="submitDivPadding ">
              <b>{{ 'SUBMISSION_INSTRUCTIONS_MSG' | translate }}</b>
            </div> 
            <!--add timer-->
          <div class="overlay">
            <p-progressSpinner *ngIf="customLoader" class="alignLoadingIcon" strokeWidth="3" animationDuration=".8s">
            </p-progressSpinner>
          </div>
        </div>
      </div>

    </form>
  </div>
  <div *ngIf="!showApp && !expiredRc" class="p-col-12 p-lg-12 p-md-12 p-sm-12 errorText">
    {{errorMsg}}
  </div>
  <div *ngIf="!showApp && expiredRc" class="p-col-12 p-lg-12 p-md-12 p-sm-12 errorText">
    {{ 'REASON_CODE_EXPIRED' | translate }}
  </div>
</div>
